import { render } from "./navSonMenuNew.vue?vue&type=template&id=8c0f7c26&scoped=true"
import script from "./navSonMenuNew.vue?vue&type=script&lang=js"
export * from "./navSonMenuNew.vue?vue&type=script&lang=js"

import "./navSonMenuNew.vue?vue&type=style&index=0&id=8c0f7c26&scoped=true&lang=less"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c0f7c26"]])

export default __exports__